import styled from 'styled-components'
export const MainWrapper = styled.section`
height:441px;
background: linear-gradient(90deg, #AC32E4 0%, #7918F2 48%, #4801FF 100%);
display:flex;
flex-direction:row;
justify-content:space-between;
padding: 60px 60px 60px 80px;
position:relative;

@media(max-width: 800px) {
    display:flex;
    flex-direction:column;
    width:400px;

    div:last-child {
      display:none;
    }
  }
`

export const GoldenTitle = styled.h1`
font-family: Poppins;
font-style: normal;
font-weight: 700;
font-size: 52px;
line-height: 78px;
color: #E2C668;
margin-bottom:0px;
`;

export const GoldenTicketSubtitle = styled.p`

font-style: normal;
font-weight: normal;
font-size: 20px;
line-height: 28px;
font-family: 'Roboto', sans-serif;
color: #FFFFFF;
`

export const ButtonJoinUs = styled.button`
margin-top:25px;
background: linear-gradient(90deg, #7918F2 48%, #4801FF 100%);
border: 3px solid #000000;
box-sizing: border-box;
font-family: Poppins;
font-style: normal;
font-weight: 600;
font-size: 34px;
line-height: 51px;
padding:15px 30px;
text-align: right;
color: #FFFFFF;
text-align: right;

box-shadow: -10px -6px 0px 0px black;
`